import React, { useEffect, useState } from "react";
import Layout from "../layout/layout";
import AvCard from "./av_card";
import getStringsBasedLang from "../../strings/get_strings";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { createData } from "../../api/http-service";
import UseErrorHandling from "../../hook/UseErrorHandling";

let id = null;
export default function Scan(props) {
  const [scanResult, setScanResult] = useState();
  const token = localStorage.getItem("token");
  let location = useLocation();
  const guid = location.state.guid;
  let navigate = useNavigate();
  const handleErrorApi = UseErrorHandling();

  useEffect(() => {
    id = setInterval(() => {
      createData(`scan/start/${guid}`, { token: token })
        .then((getScanResult) => {
          if (!getScanResult?.success) {
            clearInterval(id);
            handleErrorApi(getScanResult);
            return;
          }
          const { finished_at, md5 } = getScanResult.data;
          setScanResult(getScanResult.data);
          if (finished_at) {
            clearInterval(id);
            navigate(`/results?hash=${md5}&scanid=${guid}`);
          }
        })
        .catch((error) => {
          clearInterval(id);
          if (error?.response) {
            handleErrorApi(error?.response.data);
          }
        });
    //   getScanResult(guid, { token: token }).then((res) => {
    //     if (res.success !== undefined) {
    //       clearInterval(id);
    //       navigate("/login");
    //     }
    //     if (res.data.success) {
    //       setScanResult(res.data.data);
    //       if (res.data.data.finished_at) {
    //         clearInterval(id);
    //         navigate(`/results?hash=${res.data.data.md5}&scanid=${guid}`);
    //       }
    //     }
    //   });
    }, 5000);
    return () => {
      clearInterval(id);
    };
  }, []);

  const avCardDetailsHandler = (data, index) => {
    return (
      <div
        key={index}
        className={`${
          scanResult?.avs.length === 1 ? "col-span-2" : "col-span-1"
        } xs:col-span-2 sm:col-span-2`}
      >
        <AvCard av_name={data} av_data={scanResult} />
      </div>
    );
  };

  return (
    <Layout>
      <div className="flex mt-52 mb-20 justify-center">
        <div className="m-auto w-5/6">
          <div className="gradient_blue_background" />
          <div className="text-center mb-5">
            <div className="flex justify-center items-center mb-3">
              <img
                className="w-6 ml-2"
                src={require("../../assets/icons/search.svg").default}
                alt="search"
              />
              <span className="primary_text_color font-extrabold text-2xl">
                {getStringsBasedLang("scan_title")}
              </span>
            </div>
            <span className="secondry_text_color">
              {getStringsBasedLang("scan_subTitle")}
            </span>
          </div>
          <div className={` grid px-10 grid-cols-2 gap-2 overflow-y-auto `}>
            {scanResult !== undefined &&
              scanResult.avs.map(avCardDetailsHandler)}
          </div>
        </div>
      </div>
    </Layout>
  );
}
